/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Compare_DocumentsInputs */



/**
* | output |
* | --- |
* | "Compare documents or options" |
*
* @param {Onboarding_Usage_Compare_DocumentsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_compare_documents = /** @type {((inputs?: Onboarding_Usage_Compare_DocumentsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Compare_DocumentsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dokumente oder Optionen vergleichen")
	return /** @type {LocalizedString} */ ("Compare documents or options")
});